import Accordion from "accordion-js";
// import "accordion-js/dist/accordion.min.css";

import { Checkbox } from "./checkbox";
import { IsInViewport } from "./isInViewport";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Agreement } from "./agreement";
import { Replacetype } from "./replaceGenre";
import { ReplaceIcon } from "./replaceIcon";


const init = () => {
	// set Accorditon menu
	const accordionElements = document.querySelectorAll(".accordion");
	if ( accordionElements.length >0 ) {
		accordionElements.forEach( (element) => {
			const accordion = new Accordion(element, {
				duration: 400,
				showMultiple: true,
				elementClass: "accordion_container",
				triggerClass: "accordion_head",
				panelClass: "accordion_content"
			});
		})
	}

	// footer nav on the top page
	const searchNav = document.getElementsByClassName("top__search")[0];
	if (searchNav) {
		window.addEventListener("scroll", (elm) => {
			const searchBox = document.querySelector(".top__search");
			const footerBox = document.querySelector(".footer__search");
			if (searchBox && footerBox) {
				// Search box is out.
				if (IsInViewport(searchBox)) {
					footerBox.classList.remove("is-active");
				} else {
					footerBox.classList.add("is-active");
				}
			}
		});
	}

	// Decorating checkboxes
	Checkbox();
	Agreement();
	Replacetype();
	ReplaceIcon();

	// Carousel
	const clubImages = new Swiper('.swiper', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
		  el: ".swiper-pagination",
		},
	});
}

//init
if (document.readyState !== "loading") {
	init();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		init();
	});
}

window.addEventListener("pageshow", () => {
	Checkbox();
	Agreement();
	Replacetype();
})
